import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "hidden", "results"]
  static values = { url: String, excludeIds: Array }

  connect() {
    this.timeout = null
    this.handleClickOutside = this.handleClickOutside.bind(this)
    document.addEventListener("click", this.handleClickOutside)
  }

  disconnect() {
    clearTimeout(this.timeout)
    document.removeEventListener("click", this.handleClickOutside)
  }

  search() {
    clearTimeout(this.timeout)
    this.hiddenTarget.value = ""

    const query = this.inputTarget.value.trim()
    if (query.length < 2) {
      this.hideResults()
      return
    }

    this.timeout = setTimeout(() => this.fetchResults(query), 200)
  }

  clear() {
    this.inputTarget.value = ""
    this.hiddenTarget.value = ""
    this.hideResults()
  }

  async fetchResults(query) {
    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("q", query)
    if (this.hasExcludeIdsValue) {
      this.excludeIdsValue.forEach(id => url.searchParams.append("exclude_ids[]", id))
    }

    try {
      const response = await fetch(url, { headers: { "Accept": "application/json" } })
      if (!response.ok) return this.hideResults()
      const records = await response.json()
      this.renderResults(records)
    } catch (_) {
      this.hideResults()
    }
  }

  renderResults(records) {
    const container = this.resultsTarget
    container.replaceChildren()

    if (records.length === 0) {
      this.hideResults()
      return
    }

    records.forEach(record => {
      const div = document.createElement("div")
      div.className = "px-3 py-2 cursor-pointer hover:bg-indigo-50 flex items-center justify-between gap-2"
      div.dataset.action = "click->record-autocomplete#select"
      div.dataset.recordId = record.id
      div.dataset.recordName = record.name

      const nameSpan = document.createElement("span")
      nameSpan.className = "text-sm text-gray-900 truncate"
      nameSpan.textContent = record.name
      div.appendChild(nameSpan)

      container.appendChild(div)
    })

    container.classList.remove("hidden")
  }

  select(event) {
    const div = event.currentTarget
    this.inputTarget.value = div.dataset.recordName
    this.hiddenTarget.value = div.dataset.recordId
    this.hideResults()
  }

  hideResults() {
    this.resultsTarget.replaceChildren()
    this.resultsTarget.classList.add("hidden")
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.hideResults()
    }
  }
}
